import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { ApiUrlHelper, UrlQueryParams } from '../api-url-helper';
import { HttpClientHelper } from '../http-helper';
import { map, delay } from 'rxjs/operators';
import { Utility } from '../utility';

@Injectable()
export class PollService {

  constructor(
    private _apiUrlHelper: ApiUrlHelper,
    private _httpClientHelper: HttpClientHelper,
    private _utility:Utility
  ) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
  };

  create(user, form, videoId): Observable<any> {
   // console.log(form.value);
    const apiURL = this._apiUrlHelper.urlBuilder('vote-create', {}, this._utility.isNews ? "NEWS_ENDPOINT" : "").replace('?cinema=1', this._utility.isNews ? '?cinema=3' : '?cinema=1');

    const body = new UrlQueryParams();
    body.set('title', form.value.title);
   // var options = [];
    var index = 0;
    form.value.type.options.map(o=>{
      body.append("options",o.value);
    })

    body.set('videoID', videoId);
    body.set('type', form.value.viewResults);
    body.set('selectNumber', form.value.multipleSelect === 1 ? form.value.type.options.length : 1);
    body.set('endDays', '');
    body.set('a', 1);

    return this._httpClientHelper
      .post(apiURL, body.toString(), this.httpOptions)
      .pipe(map(l => {
        return l;
      }));
  }

  get(voteId, user,isNews= 'auto'): Observable<any> {
    let isNewsRe = isNews == 'auto'?this._utility.isNews:isNews;
    const apiURL = this._apiUrlHelper.urlBuilder('vote-get-by-id', {}, 
    isNewsRe ? "NEWS_ENDPOINT" : "")
    .replace('?cinema=1', isNewsRe ? '?cinema=3' : '?cinema=1');

    const body = new UrlQueryParams();
    body.set('voteId', voteId);
    body.set('a', 1);
    // if (user && user.id) {
    // }

    return this._httpClientHelper
      .post(apiURL, body.toString(), this.httpOptions)
      .pipe(map(l => {
        const res = l[0];
        return {
          cid: res.cid,
          endDate: res.endDay,
          id: res.id,
          isShow: res.isShow,
          isVoted: res.isVoted,
          multipleOptions: res.selectNum,
          startDate: res.startTime,
          title: res.title,
          uid: res.uid,
          vid: res.vid,
          voteCount: res.voteCount,
          voteOptions: res.voteList.map(o => {
            return {
              id: o.id,
              title: o.title,
              count: o.count,
              voted: res.voteItemId?.includes(o.id),
            };
          }),
          voteViewType: res.voteViewType,
        };
      })).pipe(delay(200));
  }

  vote(voteId, options, user): Observable<any> {
    const apiURL = this._apiUrlHelper.urlBuilder('vote-vote-by-id', {}, this._utility.isNews ? "NEWS_ENDPOINT" : "")
    .replace('?cinema=1', this._utility.isNews ? '?cinema=3' : '?cinema=1');

    const body = new UrlQueryParams();
    body.set('voteId', voteId);
    body.set('a', 1);
    options.map(o => {
      body.append('voteItemId', o);
    });

    return this._httpClientHelper
      .post(apiURL, body.toString(), this.httpOptions)
      .pipe(map(l => {
        const res = l[0];
        return res;
      })).pipe(delay(200));
  }
}
